import { useState } from 'react'
import { WFHWellnessCarousel, HubspotBrochureDownload } from '.'

const WFHWellnessGuide = (props) => {
  return (
    <>
      <section className="contentmainN ptb0 pt-5">
        <div className="container customCampaignContainer">
          <div className="row d-flex align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
              <div className="subTextHeading text-left">You will get to learn:</div>
              <div>
                <ul className="mainbullets mt-4">
                  <li>The pros and cons of remote working.</li>
                  <li>Health risks of remote working and how to deal with them.</li>
                  <li>How employers can promote work-from-home employee wellness.</li>
                  <li>Pro tips for remote workers to maintain work-life balance.</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
              <WFHWellnessCarousel />
            </div>
          </div>
        </div>
      </section>
      <div id="downloadForm"></div>
      <section className="sectionSpacing">
        <div className="container customCampaignContainer">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow"
              style={{ margin: 'auto', borderRadius: '16px', padding: '60px 30px' }}
            >
              <div className="mainHeadingN ">Download Now</div>
              <div className="innerSpace guide-form">
                <HubspotBrochureDownload formID="261c4f28-9c3f-49d0-885b-86a2806cdeb7" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default WFHWellnessGuide
